import React from 'react';
import PropTypes from 'prop-types';
import FalconCardHeader from 'components/common/FalconCardHeader';
import TooltipBadge from 'components/common/TooltipBadge';
import { Card, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

const options = [
 { label: 'Todos', value: 'everyone' },
 { label: 'Agencias', value: 'agencies' },
 { label: 'Agentes', value: 'agents' }
];

const Account = () => {
 const { register, handleSubmit } = useForm();

 const onSubmit = data => console.log(data);

 return (
  <Card className="mb-3">
   <FalconCardHeader title="Ajustes de Contacto" className="py-2" />
   <Card.Body className="bg-light">
    <form onSubmit={handleSubmit(onSubmit)}>
     <div>
      <h6 className="">
       ¿De quién puedo recibir solicitudes?
       <TooltipBadge tooltip="Tipo de usuarios que pueden hacerte solicitudes de Alianzas" icon="question-circle" />
      </h6>
      <div className="ps-2 mb-2">
       {options.map(option => (
        <Form.Check
         key={option.value}
         type="radio"
         id={`profile-${option.value}`}
         label={option.label}
         className="form-label-nogutter"
         value={option.value}
         name="viewProfile"
         {...register('viewProfile')}
        />
       ))}
      </div>
     </div>

     <div>
      <h6 className="">
       ¿A quien puedo enviar solicitudes ?
       <TooltipBadge tooltip="Only The group of selected people can tag your" icon="question-circle" />
      </h6>
      <div className="ps-2">
       {options.map(option => (
        <Form.Check
         key={option.value}
         type="radio"
         id={`tag-${option.value}`}
         label={option.label}
         className="form-label-nogutter"
         value={option.value}
         name="tagSettings"
         {...register('tagSettings')}
        />
       ))}
      </div>
     </div>

     <div className="border-dashed border-bottom my-3" />

     <div className="border-dashed border-bottom my-3" />

     <div className="ps-2">
      <Form.Check
       type="switch"
       id="custom-switch"
       label="Ocultar mi telefono de contacto"
       className="form-label-nogutter"
       name="numberVisibility"
       {...register('numberVisibility')}
      />
      <Form.Check
       type="switch"
       id="custom-switch"
       label="Publicar mis Alianzas"
       className="form-label-nogutter"
       name="allowFollow"
       {...register('allowFollow')}
      />
      <Form.Check
       type="switch"
       id="custom-switch"
       label="Publicar mis Asesores"
       className="form-label-nogutter"
       name="advisers"
       {...register('advisers')}
      />
     </div>
    </form>
   </Card.Body>
  </Card>
 );
};

Account.propTypes = { setDatacompany: PropTypes.func };

export default Account;
